const formFields = require('../formFields/formFields');

const TILE_VISIBLE_COUNT = 6;

/**
* Builds an array of consultant objects from DOM.
* @param {string} selector - Tile selector.
* @returns {Object[]} Array of consultant objects.
*/
function getConsultantsFromElements(selector) {
    const consultants = [];
    $(selector).each(function () {
        const $tile = $(this);
        consultants.push({
            lang: ($tile.data('language') || '').toString(),
            spec: ($tile.data('specialist') || '').toString(),
            cert: ($tile.data('certification') || '').toString(),
            element: $tile
        });
    });
    return consultants;
}

/**
* Gets selected checkbox values for a given filter name.
* @param {string} name - Checkbox name.
* @returns {string[]} Selected values.
*/
function getSelectedValues(name) {
    return $(`.ibc-search-filter-tray input[name="${name}"]:checked`)
        .map(function () { return $(this).val().trim(); })
        .get();
}

/**
* Gets selected language or returns true if none selected.
* @returns {string|boolean} Selected value or `true` if the select is empty.
*/
function getSelectedLanguage() {
    const val = $('.ibc-search-filter-tray .profile-languages-select').val();
    return (!val || val.trim() === '') ? true : val.trim();
}

/**
* Saves the filter state to DOM data attributes for retaining.
*/
function saveFilterStateToDataAttrs() {
    $('.ibcsearch-page .filter-outer')
        .attr('data-certification', getSelectedValues('certification').join('|'))
        .attr('data-specialties', getSelectedValues('specialties').join('|'))
        .attr('data-language', getSelectedLanguage() || '');
}

/**
* Applies retained filter values back to the UI.
*/
function applyFilterStateFromDataAttrs() {
    const $outer = $('.ibcsearch-page .filter-outer');
    const certs = ($outer.attr('data-certification') || '').split('|').filter(Boolean);
    const specs = ($outer.attr('data-specialties') || '').split('|').filter(Boolean);
    const lang = $outer.attr('data-language') || '';

    certs.forEach(v => $(`.ibc-search-filter-tray input[name="certification"][value="${v}"]`).prop('checked', true));
    specs.forEach(v => $(`.ibc-search-filter-tray input[name="specialties"][value="${v}"]`).prop('checked', true));

    if (lang && lang !== 'true') {
        $('.ibc-search-filter-tray .profile-languages-select').val(lang);
    } else {
        $('.ibc-search-filter-tray .profile-languages-select').val('').change();
    }
    formFields.updateSelect();
}

/**
* Checks if a filter matches a tile's comma-separated values.
* @param {string[]|boolean} selected - Selected filter values, or true (no filter).
* @param {string} tileValue - Tile's comma-separated data value.
* @returns {boolean} True if there's a match or no filter, false otherwise.
*/
function matchesFilter(selected, tileValue) {
    if (selected === true || selected.length === 0) return true;
    const values = tileValue.split(',').map(v => v.trim());
    return values.some(v => selected.includes(v));
}

/**
* Filters consultants array based on selected filters.
* @param {Object[]} consultants - All consultants.
* @returns {Object[]} Filtered consultants.
*/
function filterConsultants(consultants) {
    const selectedLang = getSelectedLanguage();
    const selectedSpecs = getSelectedValues('specialties');
    const selectedCerts = getSelectedValues('certification');

    return consultants.filter(c =>
        matchesFilter(selectedSpecs, c.spec) &&
        matchesFilter(selectedLang, c.lang) &&
        matchesFilter(selectedCerts, c.cert)
    );
}

/**
* Shows consultants and toggles Load More button.
* @param {Object[]} consultantsToShow - Consultants to display.
* @param {Object[]} allFiltered - All filtered consultants.
 * @param {string} loadMoreFlag - The type of load more btn, e.g., 'loadMoreBtn' or 'filter-load-more-btn'.
*/
function displayConsultants(consultantsToShow, allFiltered, loadMoreFlag) {
    $('.ibc-card-container').addClass('d-none').removeClass('filtered-tile');

    allFiltered.forEach(c => {
        c.element.addClass('filtered-tile');
    });

    $('.ibcsearch-page .tiles-count').text(allFiltered.length);

    if (allFiltered.length > consultantsToShow.length) {
        $('.filter-load-more-btn').removeClass('d-none');
    } else {
        $('.filter-load-more-btn').addClass('d-none');
    }

    consultantsToShow.forEach(c => {
        c.element.removeClass('d-none');
    });

    if (loadMoreFlag) {
        $('#loadMoreBtn').removeClass('d-none').addClass('d-block');
    } else {
        $('#loadMoreBtn').removeClass('d-block').addClass('d-none');
    }

    if (allFiltered.length) {
        $('body').find('.js-no-filtered-stores').addClass('d-none');
    } else {
        $('body').find('.js-no-filtered-stores').removeClass('d-none');
    }
}

/**
* Main filtering logic triggered by "Show Results".
*/
function filterTiles() {
    const consultants = getConsultantsFromElements('.ibc-card-container');
    const filtered = filterConsultants(consultants);

    displayConsultants(filtered.slice(0, TILE_VISIBLE_COUNT), filtered, false);

    saveFilterStateToDataAttrs();
}

/**
* Clears all filters and resets results.
*/
function clearFilters() {
    $('.ibc-search-filter-tray input[type="checkbox"]').prop('checked', false);
    $('.ibc-search-filter-tray .profile-languages-select').val('').change();

    const consultants = getConsultantsFromElements('.ibc-card-container');
    displayConsultants(consultants.slice(0, TILE_VISIBLE_COUNT), consultants, true);

    $('.filter-load-more-btn').addClass('d-none');

    $('.ibcsearch-page .filter-outer').removeAttr('data-certification data-specialties data-language');
}

/**
* Assigns unique IDs to checkboxes to avoid duplication.
*/
function assignUniqueCheckboxIds() {
    $('.ibc-search-filter-tray .filter-option-checkbox').each(function (index) {
        const $this = $(this);
        const $label = $this.next('label');
        const uniqueId = `${$this.attr('id')}-cloned-${index}`;
        $this.attr('id', uniqueId);
        $label.attr('for', uniqueId);
    });
}

module.exports = {
    filterFuntionalities: function () {
        $('body').on('click', '.show-results-btn', filterTiles);
        $('body').on('click', '.clear-all-btn', clearFilters);
        $('body').on('ibcSearchFilterRetainValues', applyFilterStateFromDataAttrs);
        $('body').on('ibcSearchFilterIdUpdate', assignUniqueCheckboxIds);

        $('body').on('click', '.filter-load-more-btn', function () {
            const consultants = getConsultantsFromElements('.ibc-card-container.filtered-tile');
            const filtered = filterConsultants(consultants);
            const currentlyShown = $('.filtered-tile:not(.d-none)').length;

            displayConsultants(filtered.slice(0, currentlyShown + TILE_VISIBLE_COUNT), filtered, false);
        });
    },
    filterKeyDown: function () {
        $('body').on('keydown', '.filter-outer', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                $('.filter-outer').trigger('click');
            }
        });

        $('body').on('keydown', '.filter-option', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                $(this).find('label').click();
            }
        });

        $('body').on('keydown', '.custom-select', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                var hasOpened = false;
                if ($(this).hasClass('current-item')) hasOpened = true;
                var select = $(this).find('.profile-languages-select');
                select.siblings('.selected-option').click();
                if (hasOpened) $(this).focus();
            }
        });

        $('body').on('keydown', '#tray-modal-default .clear-all-div', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                $(this).find('button').click();
            }
        });

        $('body').on('keydown', '#tray-modal-default .show-results-div', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                $(this).find('button').click();
            }
        });
    }
};
